// Offline-first hash-chained event log for the polling device.
// Stored in localStorage so ballot casting does NOT require the network.

const KEY = (boothId) => `evm.chain.${boothId}`;
const LOCK_KEY = (boothId) => `evm.voted.${boothId}`;

async function sha256(str) {
  const buf = new TextEncoder().encode(str);
  const hashBuf = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hashBuf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function readChain(boothId) {
  try {
    return JSON.parse(localStorage.getItem(KEY(boothId)) || "[]");
  } catch {
    return [];
  }
}

export function clearBooth(boothId) {
  localStorage.removeItem(KEY(boothId));
  localStorage.removeItem(LOCK_KEY(boothId));
}

export async function appendEvent(boothId, kind, payload) {
  const chain = readChain(boothId);
  const last = chain[chain.length - 1];
  const prev_hash = last ? last.hash : "0".repeat(64);
  const timestamp = new Date().toISOString();
  const body = JSON.stringify({ kind, payload, ts: timestamp });
  const hash = await sha256(prev_hash + body);
  const event = {
    event_id: crypto.randomUUID(),
    booth_id: boothId,
    kind,
    payload,
    timestamp,
    prev_hash,
    hash,
  };
  chain.push(event);
  localStorage.setItem(KEY(boothId), JSON.stringify(chain));
  return event;
}

export function markVoted(boothId, voterId) {
  const voted = JSON.parse(localStorage.getItem(LOCK_KEY(boothId)) || "{}");
  voted[voterId] = new Date().toISOString();
  localStorage.setItem(LOCK_KEY(boothId), JSON.stringify(voted));
}

export function hasVoted(boothId, voterId) {
  const voted = JSON.parse(localStorage.getItem(LOCK_KEY(boothId)) || "{}");
  return !!voted[voterId];
}

export function countBy(boothId, kind) {
  return readChain(boothId).filter((e) => e.kind === kind).length;
}

export function newVvpatSerial(boothId) {
  const n = countBy(boothId, "ballot.cast") + 1;
  return `VVPAT-${boothId}-${String(n).padStart(4, "0")}`;
}
